import {
  Layout,
  Row,
  Col,
  Avatar,
  Modal,
  Button as AntdButton,
  Button,
  Dropdown,
  Skeleton,
  Menu,
  Radio,
  Select,
  Badge,
} from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LogoIcon } from "../assets/Icons/logoo.svg";
import staticProfileIcon from "../assets/Images/profile-icon.svg";
import styled from "styled-components";
import { DEVICE } from "../common/device";
// import Icon from "../Component/Reusable/SideNavIcon";
import { setIsLoggedIn } from "../Redux/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
// import TymeplusPay from "../assets/Icons/TymeplusPay.svg";
// import TymeplusHr from "../assets/Icons/TymeplusHR.svg";
// import TymeplusCRM from "../assets/Icons/CRM.svg";
import messages from "../assets/Icons/messages.svg";
import bell from "../assets/Icons/bell.svg";
import { useEffect, useRef, useState } from "react";
import {
  setInitialLoader,
  setMenuItemData,
  setActiveMenuList,
  setRole,
  setViewingAsPeopleId,
  adminMenuItem,
  tutorMenuItem,
  learnerMenuItem,
  setOrgLogoUrl,
} from "../Redux/systemSlice";
import { DownOutlined } from "@ant-design/icons";
import UseApi from "../Component/Reusable/CallApi/UseApi";
import { ReactComponent as BellSvgrepo } from "../assets/bell-svgrepo-com 1.svg";

const AntHeader = Layout.Header;

const StyledAntHeader = styled(AntHeader)`
  background: #ffffff;
  z-index: 9;
  height: auto;
  line-height: 1.2;
  padding: 0px 0px;
  border-bottom: 1px solid #f0f0f0;
  .header_container_style {
    padding: 10px 0px;
  }
  .header_logo_title {
    margin: 0px;
    margin-left: 20px;
    cursor: pointer;
    margin-top: 10px;
  }
  .administrator_lists {
    padding: 16px;
    border-radius: 8px;
  }
  .administrator_list_items {
    background-color: unset !important;
    padding: unset !important;
    padding-bottom: 8px !important;
  }
  @media ${DEVICE.tablet} {
    padding: 0.5rem 0px;
  }
  .left-header-skeleton {
    margin: 10px;
  }
  .right-header-skeleton {
    margin: 10px;
  }
  .menuIcon_container {
    margin-right: 160px;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    // &:hover {
    //   border-radius: 6px;
    //   background-color: rgba(116, 176, 234, 0.25);
    // }
  }
  .app_store_box {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #fff;
  }

  .app_store_icon {
    color: #fff;
    width: 24px;
    height: 24x;
    margin-right: 15px;
  }
  .button-dropdown {
    width: 168px;
    height: 35px;
    border-radius: 8px;
    border-color: rgba(31, 36, 59, 1);
  }
  .button-dropdown:hover {
    border-color: rgba(31, 36, 59, 1) !important;
    color: rgba(31, 36, 59, 1) !important;
  }

  .icon-dropdown {
    width: 8px;
    height: 8px;
  }
  .a-style {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 168px;
  }

  .toggle_menu_box {
    position: absolute;
    gap: 10px;
    top: 50px;
    right: 85px;
    padding: 10px;
    width: 200px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(199, 229, 255, 0.44);
  }

  .menu_icon_circle {
    width: 45%;
    img {
      cursor: pointer;
    }
  }
  .radio-style .ant-dropdown-menu {
    background-color: #ffffff !important;
  }
  .administrator_lists .ant-select {
    max-width: 188px !important;
    width: 188px !important;
  }
  .administrator_lists .ant-select-selector {
    max-width: 188px !important;
    width: 188px !important;
  }
  .administrator_lists .ant-select-selection-item,
  .administrator_lists .ant-select-selection-placeholder {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 160px;
  }
  .ant-dropdown-menu .ant-dropdown-menu-item {
    background-color: #ffffff !important;
  }

  .circle {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: gray;
    margin-right: 8px;
  }

  .circle.active {
    background-color: green; /* Highlight selected role */
  }
`;

const RightCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const ButtonIcon = styled(AntdButton)`
  padding-left: 5px;
  padding-right: 5px;
  width: auto !important;
  border-radius: 5px !important;
  // font-weight: 600 !important;
  border: none;
  margin-top: 10px;
  margin-left: 0px;
  color: #1f243b;
  font-weight: 400;
  font-size: 16px;

  svg {
    margin-right: 0px !important;
  }
`;

const ButtonContainer = styled.div`
  padding: 0px 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* flex-wrap: wrap; */
  gap: 14px;

  @media ${DEVICE.tablet} {
    padding: 0px 8px;
    flex-wrap: wrap;
  }

  @media ${DEVICE.mobileL} {
    padding: 0px 5px;
    flex-wrap: wrap;
  }
`;

const StyledAvatar = styled(Avatar)`
  padding: 0;
  background-color: transparent;
  vertical-align: middle;
  cursor: pointer;
`;

const Header = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const dropdownRef = useRef(null);

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const initialLoader = useSelector(
    (state) => state.systemTracking.initialLoader
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setInitialLoader(false));
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const logoutUser = () => {
    Modal.confirm({
      title: "Confirm",
      icon: "",
      content: "Are you sure you want to logout?",
      okText: "Logout",
      cancelText: "Cancel",
      onOk: () => {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("users");
        dispatch(setIsLoggedIn(false));
      },
    });
  };

  // const handleToggleMenu = () => {
  //   setToggleMenu(!toggleMenu);
  // };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setToggleMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const role = useSelector((state) => state.systemTracking.role);
  const clientId = useSelector((state) => state.authTracking.userInfo?.clientId);
  const viewingAsPeopleId = useSelector((state) => state.systemTracking.viewingAsPeopleId);
  const [selectedLabel, setSelectedLabel] = useState(role || "Administrator");
  const { data: peopleData, request: peopleRequest } = UseApi();
  const { data: accountData, request: accountRequest } = UseApi();
  const { request: activityRequest } = UseApi();
  const [notifications, setNotifications] = useState([]);
  // undefined = not fetched yet, null = fetched but no logo uploaded.
  // Settings > Account's save dispatches this directly on success, so the
  // header picks up a logo change immediately instead of only after a
  // hard refresh remounts this component and re-runs the fetch below.
  const reduxOrgLogoUrl = useSelector((state) => state.systemTracking.orgLogoUrl);

  // The "TymeplusLearn Africa" mark is a static default - if the company
  // has uploaded its own logo (Settings > Account > Logo), show that
  // everywhere instead. Falls back to the default whenever no logo has
  // been uploaded, exactly like the Account page's own Logo field does.
  useEffect(() => {
    if (!clientId) return;
    accountRequest({ endPoint: `/settings/getaccount/${clientId}`, method: "get" }).catch(() => {});
  }, [clientId]);
  useEffect(() => {
    if (accountData?.response) {
      dispatch(setOrgLogoUrl(accountData.response[0]?.logo || null));
    }
  }, [accountData, dispatch]);
  const orgLogoUrl = reduxOrgLogoUrl !== undefined ? reduxOrgLogoUrl : accountData?.response?.[0]?.logo || null;

  // Real, dedicated notifications (tymeplushrlmsnotifications) - only
  // ever inserted by the backend at a genuine notification-worthy event
  // (currently: handlers/tymeplushrlmsmessage/app.mjs's sendAsPerson,
  // when a message actually lands in the Admin's Inbox). Not the same
  // data as Dashboard's Recent Activity/Activity Log report, which is
  // internal admin-action history, not user-facing notifications.
  // The bell just links to the full Notification page (Figma
  // node-id=2297-14417) now, same as the message icon links to /messages
  // - this fetch only exists to keep the unread-count badge live.
  useEffect(() => {
    if (!clientId) return;
    activityRequest({ endPoint: `/notification/getnotifications/${clientId}`, method: "get" })
      .then((res) => setNotifications(res?.response || []))
      .catch(() => {});
  }, [clientId]);
  const unreadCount = notifications.filter((notification) => !notification.is_read).length;
  const listitems = [
    {
      label: "Administrator",
      key: "0",
    },
    {
      label: "Tutor",
      key: "1",
    },

    {
      label: "Learner",
      key: "2",
    },
  ];
  const people = peopleData?.response || [];

  // There's no separate learner login anywhere in this app - the JWT is
  // always the Owner/Admin session, with no concept of "the logged-in
  // person is employee #4." Learner mode is a real "view as" preview
  // instead: pick a real person, and My Courses/Dashboard show that
  // person's real enrollment data (see learnerMenuItem's comment in
  // systemSlice.js). Defaults to the first real person on switching in.
  const handleMenuClick = async (label) => {
    setSelectedLabel(label);
    dispatch(setRole(label));
    dispatch(setActiveMenuList([]));

    if (label === "Tutor") {
      dispatch(setMenuItemData(tutorMenuItem));
      navigate("/tutor-dashboard");
    } else if (label === "Administrator") {
      dispatch(setMenuItemData(adminMenuItem));
      navigate("/dashboard");
    } else if (label === "Learner") {
      dispatch(setMenuItemData(learnerMenuItem));
      if (!viewingAsPeopleId) {
        const result = await peopleRequest({ endPoint: `/people/getuser/${clientId}`, method: "get" }).catch(() => null);
        const firstPerson = result?.response?.[0];
        if (firstPerson) {
          dispatch(setViewingAsPeopleId(firstPerson.people_id));
        }
      }
      navigate("/learner-dashboard");
    }
  };

  const menu = (
    <StyledAntHeader>
      <div style={{ marginLeft: "-15px", width: "220px", marginTop: "16px", overflow: "hidden" }}>
        <Menu className="administrator_lists">
          <Radio.Group value={selectedLabel} style={{ width: "100%" }}>
            {listitems.map((item) => (
              <Menu.Item
                key={item.key}
                onClick={() => handleMenuClick(item.label)}
                className="administrator_list_items"
                // style={{ display: "flex", alignItems: "center" }}
              >
                <Radio value={item.label}>{item.label}</Radio>
              </Menu.Item>
            ))}
            {selectedLabel === "Learner" && (
              <Menu.Item className="administrator_list_items">
                <Select
                  size="small"
                  style={{ width: "100%" }}
                  popupMatchSelectWidth={260}
                  placeholder="Viewing as..."
                  value={viewingAsPeopleId || undefined}
                  optionFilterProp="label"
                  onClick={(e) => e.stopPropagation()}
                  onChange={(value) => dispatch(setViewingAsPeopleId(value))}
                  options={people.map((person) => ({
                    value: person.people_id,
                    label: `${person.first_name || ""} ${person.last_name || ""}`.trim(),
                  }))}
                  optionRender={(option) => (
                    <div
                      title={option.data.label}
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {option.data.label}
                    </div>
                  )}
                />
              </Menu.Item>
            )}

            <ButtonIcon disabled onClick={logoutUser}>Logout</ButtonIcon>
          </Radio.Group>
        </Menu>
      </div>
    </StyledAntHeader>
  );

  return (
    <StyledAntHeader>
      <Row ref={dropdownRef} className="header_container_style">
        <Col xs={16}>
          <Row>
            <Col>
              {initialLoader ? (
                <Skeleton.Button active={true} shape="default" />
              ) : orgLogoUrl ? (
                <img
                  src={orgLogoUrl}
                  alt="Organization logo"
                  className="mx-4 header_logo_title"
                  style={{ height: 32, maxWidth: 160, objectFit: "contain" }}
                />
              ) : (
                <LogoIcon className="mx-4 header_logo_title" />
              )}
            </Col>
          </Row>
        </Col>

        <RightCol xs={8}>
          <Col className="menuIcon_container">
            {/* {initialLoader ? (
              <Skeleton.Avatar active={true} shape="circle" />
            ) : (
              <Dropdown
                trigger={["click"]}
                className="app_store_box"
                overlay={
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleMenu();
                    }}
                  ></div>
                }
              >
                <img
                  src={menuIconBlack}
                  className="app_store_icon"
                  onClick={handleToggleMenu}
                />
              </Dropdown>
            )} */}
            <img
              src={messages}
              className="app_store_icon"
              style={{ cursor: "pointer" }}
              alt="Messages"
              onClick={() => navigate("/messages")}
            />
            <Badge count={unreadCount}  offset={[-4, 4]}>
              <BellSvgrepo
                src={bell}
                className="app_store_icon"
                style={{ cursor: "pointer" }}
                alt="Notifications"
                onClick={() => navigate("/notification")}
              />

            </Badge>
            {/* <Button className="button-dropdown">
              <Dropdown
                menu={{items: listitems}}
                trigger={['click']}
              >
                <a onClick={(e) => e.preventDefault()}
                  className="a-style"
                >  
                    {selectedLabel}
                    <DownOutlined className="icon-dropdown"/>
                  
                </a>
              </Dropdown>
            </Button> */}
            <ButtonContainer>
              <StyledAvatar
                onClick={() => {
                  navigate("/my-profile");
                }}
                shape="square"
                src={staticProfileIcon}
                size="default"
              ></StyledAvatar>
            </ButtonContainer>
            <Button className="button-dropdown">
              <Dropdown
                className="radio-style administrator-dropdown-container"
                overlay={menu}
                trigger={["click"]}
                // overlayStyle={{ marginTop: "12px" }}
              >
                <a onClick={(e) => e.preventDefault()} className="a-style">
                  {selectedLabel} <DownOutlined className="icon-dropdown" />
                </a>
              </Dropdown>
            </Button>

            {/* <div className="role-dropdown">
                <button className="dropdown-toggle">
                  {selectedRole} <DownOutlined className="dropdown-symbol"/>
                </button>
              </div> */}
          </Col>

          {/* {toggleMenu && (
            <Row className="toggle_menu_box" gutter={12}>
              <Col className="menu_icon_circle">
                <img src={TymeplusHr} alt="TymeplusHr" />
              </Col>
              <Col className="menu_icon_circle">
                <img src={TymeplusPay} alt="TymeplusPay" />
              </Col>
              <Col className="menu_icon_circle">
                <img src={TymeplusCRM} alt="TymeplusCRM" />
              </Col>
            </Row>
          )} */}
        </RightCol>
      </Row>
    </StyledAntHeader>
  );
};

export default Header;
